import React, {useState,useEffect} from 'react'
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";


// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
margin-left: 0.2em;
margin-top: 0.5em;
`;

function Loaders(props) {
  // let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#ffffff");


  useEffect(() => {
    
  }, [props.loads]);
  return (
    <div className="sweet-loading" style={{display: "inline"}}>
      <BeatLoader color={color} loading={props.loads} css={override} size={14} />
  </div>
  )
}

export default Loaders